import React, { memo } from 'react';
import MyTextChatContainer from './MyTextChatContainer';
import OtherTextChatContainer from './OtherTextChatContainer';
import SystemChatContainer from './SystemChatContainer';

const ChatChunk = ({
  messages,
  membersMap,
  currentUserId,
  chunkId = "realtime",
  isFirstChunk = false,
  meetingId,
  placeLatitude,
  placeLongitude,
  blockedIdSet,
}) => {
  // console.log("청크 렌더링됨", messages.length, "개 메시지", "청크 ID:", chunkId);
  const formatDateOnly = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일`;
  };

  const getDateKey = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
  };

  const isSameDay = (date1, date2) => {
    if (!date1 || !date2) return false;
    return getDateKey(date1) === getDateKey(date2);
  };

  const getTimeKey = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}-${date.getHours()}-${date.getMinutes()}`;
  };

  const DateSeparator = ({ date }) => (
    <div className="flex justify-center my-4">
      <div className="bg-gray-200 text-gray-600 text-xs px-3 py-1 rounded-full">
        {formatDateOnly(date)}
      </div>
    </div>
  );

  const renderMessage = (message, prevMessage) => {
    const isMyMessage = message.memberId === currentUserId;

    const showProfile = !isMyMessage && (
      !prevMessage ||
      prevMessage.memberId !== message.memberId ||
      !isSameDay(prevMessage.createdAt, message.createdAt)
    );

    const showTime = !prevMessage ||
                    prevMessage.memberId !== message.memberId ||
                    getTimeKey(prevMessage.createdAt) !== getTimeKey(message.createdAt);

    if (message.type === 'SYSTEM') {
      return (
        <SystemChatContainer 
          content={message.content}
          createdAt={message.createdAt}
          meetingId={meetingId}
          membersMap={membersMap}
          placeLatitude={placeLatitude}
          placeLongitude={placeLongitude}
        />
      );
    }

    if (isMyMessage) {
      return (
        <MyTextChatContainer
          message={message.content}
          time={message.createdAt}
          showTime={showTime}
        />
      );
    } else {
      const senderInfo = membersMap.get(message.memberId);

      // 차단된 사용자 메시지 마스킹
      const isBlocked = blockedIdSet && message.memberId && blockedIdSet.has(message.memberId);
      const maskedMessage = isBlocked ? '차단된 밥친구입니다' : message.content;

      return (
        <OtherTextChatContainer
          message={maskedMessage}
          time={message.createdAt}
          senderName={senderInfo?.name || '알 수 없음'}
          senderProfileImageUrl={senderInfo?.imageUrl}
          showProfile={showProfile}
          showTime={showTime}
        />
      );
    }
  };

  return (
    <>
      {messages.map((message, index) => {
        // 이전 메시지: 청크 내 이전 메시지만 고려 (첫 번째 청크가 아닌 경우 첫 메시지는 항상 새 그룹)
        const prevMessage = index > 0 ? messages[index - 1] : null;

        // 날짜가 바뀌면 구분선 표시
        const showDateSeparator = prevMessage &&
          !isSameDay(prevMessage.createdAt, message.createdAt);

        // 새로운 그룹 시작 조건
        const isNewGroup = !prevMessage ||
          prevMessage.memberId !== message.memberId ||
          showDateSeparator ||
          (index === 0 && !isFirstChunk); // 첫 번째 청크가 아닌 경우 첫 메시지는 항상 새 그룹

        return (
          <React.Fragment key={`${message.id}-${index}`}>
            {showDateSeparator && <DateSeparator date={message.createdAt} />}
            <div className={isNewGroup ? 'mt-3' : ''}>
              {renderMessage(message, index, prevMessage)}
            </div>
          </React.Fragment>
        );
      })}
    </>
  );
};

ChatChunk.displayName = 'ChatChunk';

export default memo(ChatChunk);
